import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Modal, TextInput, CheckBox, DropdownSelector } from 'hyperdb-utils';

const ExportTab = (props) => {
  const channelsSettings = props.objectData.export_channels_settings || [];
  const displayRemoteId = () => {
    const selectedChannelId = props.editedSettings.channel_id ? props.editedSettings.channel_id.value[1] : null;
    if (!selectedChannelId) return false;
    const selectedChannel = props.channels.find(c => c.id === selectedChannelId);
    return !['Domino', 'ICAL'].includes(selectedChannel.protocol);
  };

  const handleToggleModalForm = (bool, indexEditedSettings = -1) => {
    const editedSettings = bool && indexEditedSettings !== -1
      ? { ...channelsSettings[indexEditedSettings] }
      : { units_remote_ids: [] };
    editedSettings.units_remote_ids = props.objectData.units.map(unit => {
      const correspondingUnit = (editedSettings.units_remote_ids || []).find(u => u.number === unit.number);
      return correspondingUnit || { number: unit.number };
    });
    const selectedChannelId = editedSettings.channel_id ? editedSettings.channel_id.value[1] : null;
    const channelsToList = props.channels.filter(channel => {
      return channel.id === selectedChannelId || !channelsSettings.some(setting => setting.channel_id.value[1] === channel.id);
    });
    props.api.property.setData({ showModalFormSettings: bool, indexEditedSettings, editedSettings, channelsToList });
  };
  const handleChangeSettings = (attributeName, field) => {
    const editedSettings = { ...props.editedSettings };
    let value = field.value;
    if (attributeName === 'channel_id') {
      if (!field.value) return;
      value = editedSettings.channel_id
        ? { ...editedSettings.channel_id, value: ['channels', field.value] }
        : { $type: 'reference', value: ['channels', field.value] };
    }
    editedSettings[attributeName] = value;
    props.api.property.setData({ editedSettings });
  };
  const handleClickSettingsCheckbox = (attributeName) => {
    const checked = !props.editedSettings[attributeName];
    handleChangeSettings(attributeName, { value: checked });
  };
  const handleSaveSettings = () => {
    const _channelsSettings = channelsSettings.slice();
    const editedSettings = { ...props.editedSettings };
    if (editedSettings.channel_id && editedSettings.channel_id.value[1]) {
      if (props.indexEditedSettings === -1) {
        _channelsSettings.push(editedSettings);
      } else {
        _channelsSettings[props.indexEditedSettings] = editedSettings;
      }
      props.onChange('export_channels_settings', { value: _channelsSettings });
      props.api.property.setData({ showModalFormSettings: false, indexEditedSettings: -1, editedSettings: null });
    }
  };

  const handleToggleModalDelete = (indexDeleteSettings = -1) => {
    const showModalDeleteSettings = indexDeleteSettings !== -1;
    props.api.property.setData({ showModalDeleteSettings, indexDeleteSettings });
  };
  const handleDeleteSettings = () => {
    const _channelsSettings = channelsSettings.slice();
    _channelsSettings.splice(props.indexDeleteSettings, 1);
    props.onChange('export_channels_settings', { value: _channelsSettings });
    props.api.property.setData({ showModalDeleteSettings: false, indexDeleteSettings: -1 });
  };

  const handleChangeUnitRemoteId = (index, field) => {
    const editedSettings = { ...props.editedSettings };
    const settingsUnits = (editedSettings.units_remote_ids || []).map(unit => ({ ...unit }));
    settingsUnits[index].remote_id = field.value;
    editedSettings.units_remote_ids = settingsUnits;
    props.api.property.setData({ editedSettings });
  };

  const clientId = JSON.parse(localStorage.getItem('currentUser')).client_id;
  const baseURL = `https://pms.rentaleo.com/api/icals/${clientId}`;
  const units = parseInt(props.objectData.multi_unit) === 2 ? props.objectData.units : [{ number: 1 }];
  const icals = units.map(unit => {
    return `${baseURL}/${props.objectData.id}-${unit.number}.ics`;
  }).map((url, i) => <li key={i}>{url}</li>);
  return (
    <div style={ {display: props.show ? 'block' : 'none'} }>
      <fieldset>
        <div className="box-header">
          <span>
            <b>Channels</b>
            &nbsp;
            <button type="button" className="btn btn-xs btn-primary" onClick={ handleToggleModalForm.bind(null, true, -1) }>Add</button>
          </span>
        </div>
        <div className="table-responsive no-padding">
          <table className="table table-hover table-striped table-bordered table-responsive">
            <thead>
              <tr>
                <th>name</th>
                <th>protocol</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                channelsSettings.map((settings, i) => {
                  const selectedChannel = settings.channel_id ? props.channels.find(c => c.id === settings.channel_id.value[1]) : null;
                  if (!selectedChannel) return null;
                  return (
                    <tr key={ i }>
                      <td>{ selectedChannel.name }</td>
                      <td>{ selectedChannel.protocol }</td>
                      <td>
                        <DropdownButton title={ <span><i className="fas fa-caret" /> Actions</span> } pullRight bsSize="small" id="Menu actions">
                          <MenuItem onClick={ handleToggleModalForm.bind(null, true, i) }>Edit</MenuItem>
                          <MenuItem onClick={ handleToggleModalDelete.bind(null, i) }>Delete</MenuItem>
                        </DropdownButton>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <fieldset>
          <legend>iCal URLs</legend>
          <ul>{icals}</ul>
        </fieldset>
        {
          props.showModalFormSettings
            ? <Modal title={ props.indexEditedSettings === -1 ? 'Add channel' : 'Edit channel settings' } onClose={ handleToggleModalForm.bind(null, false) } onAccept={ handleSaveSettings.bind(null, props) }>
                <fieldset>
                  <DropdownSelector
                    label="Channel"
                    name="channel_id"
                    value={ props.editedSettings.channel_id ? props.editedSettings.channel_id.value[1] : null }
                    options={ (props.channelsToList || []).map(c => ({ name: c.name, value: c.id })) }
                    onChange={ handleChangeSettings.bind(null, 'channel_id') }
                  />
                  {
                    displayRemoteId(props.editedSettings.channel_id)
                      ? <div>
                          <TextInput
                            label="remote_id"
                            name="remote_id"
                            value={ props.editedSettings.remote_id }
                            onChange={ handleChangeSettings.bind(null, 'remote_id') }
                          />
                          {
                            parseInt(props.objectData.multi_unit) === 2
                              ? <fieldset>
                                  <legend>Units</legend>
                                  <table className="table table-hover table-striped table-bordered table-responsive">
                                    <thead>
                                      <tr>
                                        <th>number</th>
                                        <th>remote_id</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {
                                        (props.editedSettings.units_remote_ids || []).map((unit, i) => {
                                          return (
                                            <tr key={ i }>
                                              <td>
                                                {unit.number || i}
                                              </td>
                                              <td>
                                                <TextInput
                                                  label={ null }
                                                  value={ unit.remote_id }
                                                  onChange={ handleChangeUnitRemoteId.bind(null, i) }
                                                />
                                              </td>
                                            </tr>
                                          );
                                        })
                                      }
                                    </tbody>
                                  </table>
                                </fieldset>
                              : null
                          }
                        </div>
                      : null
                  }
                </fieldset>
              </Modal>
            : null
        }
        {
          props.showModalDeleteSettings
            ? <Modal title="Remove channel" onClose={ handleToggleModalDelete.bind(null, -1) } onAccept={ handleDeleteSettings.bind(null, props) }>
                Remove this channel ?
              </Modal>
            : null
        }
      </fieldset>
    </div>
  );
};

ExportTab.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  channels: React.PropTypes.array,
};

export default ExportTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/ExportTab.jsx